import { fromJS } from 'immutable';

import {
  LOAD_CLIENT_INVOICES_TABLE_SUCCESS,
  UPDATE_CLIENT_INVOICE_SUCCESS,
  DELETE_CLIENT_INVOICE_SUCCESS,
} from 'constants/ActionTypes';

const initialState = fromJS({
  dataset: [],
  pagination: {
    totalCount: null,
    pageCount: null,
    currentPage: null,
    perPage: null,
  },
});

const invoiceTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CLIENT_INVOICES_TABLE_SUCCESS:
      return state.merge(
        fromJS({
          dataset: action.invoices.items.map((invoice) => invoice.invoiceId),
          pagination: {
            totalCount: action.invoices._meta.totalCount,
            pageCount: action.invoices._meta.pageCount,
            currentPage: action.invoices._meta.currentPage,
            perPage: action.invoices._meta.perPage,
          },
        }),
      );
    case UPDATE_CLIENT_INVOICE_SUCCESS:
      return state.set('dataset', state.get('dataset').unshift(action.invoice.invoiceId));
    case DELETE_CLIENT_INVOICE_SUCCESS: {
      return state.set(
        'dataset',
        state.get('dataset').filter((id) => id !== action.invoiceId),
      );
    }
    default:
      return state;
  }
};
export default invoiceTableReducer;
